import { render } from "./BorangPMKKNP.vue?vue&type=template&id=25cb9cd2&scoped=true&ts=true"
import script from "./BorangPMKKNP.vue?vue&type=script&lang=ts"
export * from "./BorangPMKKNP.vue?vue&type=script&lang=ts"

import "./BorangPMKKNP.vue?vue&type=style&index=0&id=25cb9cd2&lang=scss&scoped=true"
import "./BorangPMKKNP.vue?vue&type=style&index=1&id=25cb9cd2&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cb9cd2"]])

export default __exports__